export default __webpack_public_path__ + "static/1289-53b67fdbe08d8d1ff1bd200e8274cd85.gif";